import React, { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { GetApps } from 'nallian-shared-ui/lib/selectors';
import { useSharedTranslation } from 'nallian-shared-ui/lib/hooks';
import { Flex } from 'nallian-shared-ui/lib/components';
import { processApps } from 'nallian-shared-ui/lib/layout/UserApps';
import CommunityCard from './CommunityCard';

const MyAppsOverview = () => {
  const { t } = useSharedTranslation();
  const myApps = useSelector(GetApps);

  const processedCommunities = useMemo(() => processApps(myApps, t), [myApps, t]);

  if (!processedCommunities.length) {
    return null;
  }

  return (
    <Flex fluid wrap="wrap" margin="0 0 2rem" alignItems="stretch">
      {processedCommunities.map(({ community, apps }) => (
        <CommunityCard key={community.id} community={community} apps={apps} />
      ))}
    </Flex>
  );
};

export default MyAppsOverview;
